import {useState, useEffect} from 'react'
import { FormGroup, Label } from 'reactstrap'

import { isNull } from '../../../izUtils'

const ProjectStatus = ({data, onChange, showErrors}) => {
    const { name, display, errors, title, values, disabled, mandatory} = data

    const [value, setvalue] = useState("")

    useEffect(() => {
        setvalue(data.value === null ? '' : data.value)
    }, [data.value])

    const handleChange = (option) => {
        setvalue(option.id)
        onChange(option.id, name)
    };

    if (display) {
        return (
            <FormGroup>
                <div className="d-flex align-items-center">
                    <Label>{title + (mandatory ? " *" : "")}</Label>
                </div>
                {!isNull(values) &&
                    <div className="d-flex">
                        {values.map((option, index) => (
                            <div key={index} className="mb-2 me-2">
                                <button style={{ border: 'none', backgroundColor: 'transparent', padding: 0 }} onClick={() => handleChange(option)} disabled={disabled}>
                                    <span className={`badge badge-project bg-${option.id} ${value === option.id ? 'active' : ''}`}>
                                        {option.title}
                                    </span>
                                </button>
                            </div>
                        ))}
                    </div>
                }
                {!isNull(showErrors) && showErrors && !isNull(errors) && errors.length !== 0 && <div style={{ color: "red", marginBottom: "10px" }}>{errors.map((error, index) => <div key={"error-"+index}>{error}</div>)}</div>}
            </FormGroup>
        )
    } else {
        return null
    }
}

export default ProjectStatus